<template>
  <div class="manage-your-account-grid">
    <div>
      <h1 class="manage-your-account-header">Manage Your Account</h1>
    </div>
    <div>
      <p class="manage-your-account-text">
        Make a payment to your existing healthcare account, set up AutoPay, access paperless statements, and more.
      </p>
    </div>
    <div>
      <SecondaryButton
        class="manage-your-account-btn"
        :text="'Manage Account'"
        @clickHandler="payNowLinkClick"
      />
    </div>
  </div>
</template>

<script>
import SecondaryButton from "@Shared/components/SecondaryButton.vue";
import router from "../../router";

export default {
  name: "ManageYourAccount",
  components: {
    SecondaryButton,
  },

  methods: {
    payNowLinkClick() {
      window.location = `${process.env.VUE_APP_BILL_PAY_PATH}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.manage-your-account-grid {
  display: grid;
  grid-template-rows: repeat(3, auto);
  row-gap: 20px;

  .manage-your-account-header {
    color: #43454d;
    font-family: Poppins;
    font-size: 40px;
    font-weight: 700;
      @media all and (max-width: $grid-breakpoint-sm) {
        font-size: 24px;
      }
  }

  .manage-your-account-text {
    @media all and (max-width: $grid-breakpoint-sm) {
        font-size: 16px;
      }
  }

  .manage-your-account-btn {
    @media all and (max-width: $grid-breakpoint-sm) {
      width: 100%;
      padding: 10px;
      border-radius: 5px;
    }
  }
}
</style>
